import { Leaf } from "lucide-react";

const ITEMS = [
    "Zero cost to your office",
    "Free white-glove installation",
    "Telemetry-driven restocking",
    "Northern Virginia",
    "571-281-1784",
    "No contracts, ever",
];

export default function Marquee() {
    const row = (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center shrink-0">
                    <span className="font-display text-xl sm:text-2xl font-bold tracking-tight text-[#F9F8F3]/80 px-8 whitespace-nowrap">
                        {item}
                    </span>
                    <Leaf className="h-4 w-4 text-[#A6CE39]/60 shrink-0" />
                </span>
            ))}
        </div>
    );

    return (
        <section
            data-testid="editorial-marquee-banner"
            aria-hidden
            className="relative bg-[#0E1E12] py-6 overflow-hidden marquee-mask border-y border-[#A6CE39]/10"
        >
            <div className="flex w-max animate-marquee">
                {row}
                {row}
            </div>
        </section>
    );
}
